export const environment = {
  production: true,
  serviceBaseUrl: 'https://dyn365api.test.uu.se/api/',
  backendApiKey: 'G35WG5K0bPjsM1Ma12GlXt6k1ztZYN3XxBGKZP3UmFteTq017nwWqc0VS5aR6KcEpNK2w3BU8KsfWNA1jeGEvYJL9FMWV1L3P3',
  MatDilalogWidth: '800px',
  MatDialogHeight: '800px',
  reCaptchaKey: ''
};
